const auth = {
  email: 'E-Mail',
  password: 'Passwort',
  welcomeMessage: 'Melden Sie sich bei Ihrem Konto an',

  validations: {
    email: {
      required: 'E-Mail ist erforderlich',
      email: 'Ungültige E-Mail-Adresse',
      emailReceived: 'Die E-Mail-Adresse, die Sie von Ihrem Administrator erhalten haben',
    },
    password: {
      required: 'Passwort erforderlich',
      password: 'Ungültiges Passwort',
    },
    otp: {
      required: 'Es ist ein 6-stelliger Code erforderlich.',
      invalid: 'Der von Ihnen eingegebene Code ist ungültig.'
    }
  },
  resetPassword: {
    email: 'E-Mail fehlt',
    resetToken: 'Das Reset-Token ist ungültig',
  },
  loginBtn: 'Login',
  toast: {
    authFailed: 'E-Mail oder Passwort sind ungültig',
    unexpectedError: 'Unerwarteter Fehler aufgetreten',
    codeInvalid: 'Die Verifizierung ist fehlgeschlagen. Bitte stellen Sie sicher, dass Sie den richtigen 6-stelligen Code eingegeben haben oder fordern Sie einen neuen an.',
    securityUpdate: 'Die Sicherheitsrichtlinien wurden aktualisiert. Wir entschuldigen uns für etwaige Unannehmlichkeiten.',
  },

  toastBlockRequest: {
    body: 'Sie wurden aufgrund zu vieler Fehlversuche vorübergehend gesperrt. Bitte versuchen Sie es später erneut.',
  },

  /** 2FA related translations below */
  twoFactorAuthSelectMessage: 'Wählen Sie die Überprüfungsmethode',
  twoFactorAuthVerifyMessage: 'Dieses Gerät verifizieren',
  twoFactorAuthVerifyLabel: 'Bitte geben Sie den 6-stelligen Code ein, den wir Ihnen gerade gesendet haben.',
  sendVerificationCodeBtn: 'Bestätigungscode senden',
  phoneMethodLabel: 'SMS',
  verifyBtn: 'Einreichen',
  resendVerificationCodeBtn: 'Code erneut senden',
  resendVerificationCodeLbl: 'Code in {{seconds}}s erneut senden.',
};

export default auth;
